// eslint-disable-next-line import/no-unresolved, import/no-extraneous-dependencies
import {
	type AttributeValueChange,
	type IsLoadingChange,
} from '@Reducers/Risk.reducer';
import { createAction } from '@reduxjs/toolkit';
import {
	type AttributeDataGridRow,
	type AttributeOption,
} from '@Types/automaticSetup.types';
import {
	type GetMetadataParams,
	type CountChange,
	type CountRename,
	type MetadataChange,
	type MetadataRename,
} from '@Types/risk.types';
// eslint-disable-next-line import/no-unresolved, import/no-extraneous-dependencies
import { type Metadata } from '@Types/risk.types';
import { addNamespace } from '@Utils/actions';

export const setCountIsLoading = createAction<IsLoadingChange>(
	addNamespace('Risk/setCountIsLoading'),
);

export const getCountAttribute = createAction<{
	key: string;
	metadata: Metadata[];
	metadataType: string;
	assetType: string;
	assetFilterId?: string;
	fieldName: string;
}>(addNamespace('Risk/getCountAttribute'));

export const getCountResolved = createAction<CountChange>(
	addNamespace('Risk/getCountResolved'),
);

export const renameCount = createAction<CountRename>(
	addNamespace('Risk/renameCount'),
);

export const setMetadataIsLoading = createAction<IsLoadingChange>(
	addNamespace('Risk/setMetadataIsLoading'),
);

export const getMetadata = createAction<GetMetadataParams>(
	addNamespace('Risk/getAssetMetadata'),
);

export const getMetadataResolved = createAction<MetadataChange>(
	addNamespace('Risk/getMetadataResolved'),
);

export const renameMetadata = createAction<MetadataRename>(
	addNamespace('Risk/renameMetadata'),
);

export const setAttributes = createAction<AttributeOption[]>(
	addNamespace('Risk/setAttributes'),
);

export const updateAttribute = createAction<AttributeOption>(
	addNamespace('Risk/updateAttribute'),
);

export const updateAttributeValuesDataGrid = createAction<
	AttributeValueChange[]
>(addNamespace('Risk/updateRiskValuesDataGrid'));
export const updateAttributeExcludedDataGrid = createAction<
	AttributeValueChange[]
>(addNamespace('Risk/updateAttributeExcludedDataGrid'));

export const setAttributeDataGrid = createAction<AttributeDataGridRow[]>(
	addNamespace('Risk/setAttributeDataGrid'),
);

export const setAttributeRangeValues = createAction<number[]>(
	addNamespace('Risk/setAttributeRangeValues'),
);

export const setAttributeRangeUnitValues = createAction<number[] | undefined>(
	addNamespace('Risk/setAttributeRangeUnitValues'),
);
